var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.7364,
    cy: 21.8341,
    rx: 14.3341,
    ry: 14.3341,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 56.1042C11.9962 55.0965 12.2216 54.1012 12.6591 53.1934C14.0321 50.4474 17.9039 48.992 21.1168 48.333C23.4338 47.8385 25.7829 47.5082 28.1465 47.3444C32.5225 46.9601 36.9238 46.9601 41.2998 47.3444C43.6632 47.5101 46.0122 47.8404 48.3296 48.333C51.5424 48.992 55.4142 50.3101 56.7872 53.1934C57.6671 55.0438 57.6671 57.192 56.7872 59.0424C55.4142 61.9257 51.5424 63.2438 48.3296 63.8753C46.0152 64.3903 43.6653 64.7299 41.2998 64.8914C37.7381 65.1933 34.1598 65.2483 30.5904 65.0561C29.7666 65.0561 28.9703 65.0561 28.1465 64.8914C25.7899 64.7319 23.449 64.3922 21.1442 63.8753C17.9039 63.2438 14.0595 61.9257 12.6591 59.0424C12.2238 58.1241 11.9987 57.1204 12 56.1042Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.84ee2f70a012064cf4e0ada716554d50.svg";
export { ForwardRef as ReactComponent };